import React, { createContext, useContext } from 'react';
import api from '../services/api';

// Create the API context
const ApiContext = createContext();

// Custom hook to use the API context
export const useApi = () => {
  return useContext(ApiContext);
};

// Provider component that wraps the app and makes API object available to any child component that calls useApi()
export const ApiProvider = ({ children }) => {
  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
};